import axios from 'axios';
import { getApiUrl } from '../utils/ApiUtils';
import { rememberInvitation, safeAuthRedirect } from '../utils/OnboardingRedirect';

export async function requestEmailVerification(user, redirectUrl) {
  if (!user) throw Object.assign(new Error('Sign in again'), { code: 'auth/user-token-expired' });
  const redirect = safeAuthRedirect(redirectUrl);
  rememberInvitation(redirect);
  const idToken = await user.getIdToken(true);
  const response = await axios.post(getApiUrl('auth/email-verification'), { idToken, redirect }, { timeout: 15000 });
  if (!['queued', 'already_verified'].includes(response.data?.status)) throw new Error('Unexpected verification response');
  return response.data;
}

export function verificationFailureMessage(error) {
  const code = error.response?.data?.code || error.code;
  if (['VERIFICATION_RATE_LIMITED', 'AUTH_RATE_LIMITED'].includes(code)) return 'Vänta en stund innan du begär en ny verifieringslänk. Kontrollera även skräpposten.';
  if (error.response?.status === 401 || ['auth/user-token-expired', 'auth/invalid-user-token'].includes(code)) return 'Logga in igen med ditt befintliga konto för att begära en ny verifieringslänk.';
  if (!error.response && ['ERR_NETWORK', 'ECONNABORTED', 'auth/network-request-failed'].includes(code)) return 'Kontrollera din internetanslutning och försök skicka verifieringslänken igen.';
  return 'Verifieringsmejlet kunde inte skickas. Ditt konto finns kvar. Vänta en stund och försök igen.';
}

export function verificationNotice(result) {
  return result.status === 'already_verified'
    ? 'Din e-postadress är redan verifierad. Logga in igen för att fortsätta.'
    : 'En verifieringslänk är på väg. Kontrollera inkorgen och skräpposten.';
}
